<template lang="html">
  <div id="loginPage">
    <img src="../assets/img/logo.png" class="logo">
    <h1>座席表ログインページ</h1>
    <form @submit.prevent="doLogin()" id="loginform">
      <div class="inputArea">
        <div>
          <label for="idtext" class="labels">ユーザーID:</label>
          <input type="text" id="idtext" placeholder="id" v-model="idtext" pattern="^[0-9A-Za-z\._]+$" />
        </div>
        <div>
          <label for="password" class="labels">パスワード：</label>
          <input v-if="!isShownPassword" type="password" id="password" placeholder="password"  v-model="password" pattern="^[0-9A-Za-z\._]+$" />
          <input v-if="isShownPassword" type="text" id="password" placeholder="password" v-model="password" pattern="^[0-9A-Za-z\._]+$" />
        </div>
        <div>
          <input type="checkbox" id="showPass"  v-model="isShownPassword"  />
          <label for="showPass">パスワードを表示する</label>
        </div>
      </div>
      <el-button type="success" @click="doLogin">ログイン</el-button><br><br>
    </form>

    <section>
      <div>
        <h1 class="information_list_title">お知らせ</h1>
        <div id="information_list">
          <table id="information_list" class="kokuban">
            <span v-for="(information_list, index) in information_list"
            :key="'information_list' + index" class="tablea">
              <tr class="info_Heading">
                <td style="width:40px;">
                  <span class="information_img">
                    <img src="../assets/img/icon4neworange.gif" v-if="checke_date(information_list)">
                  </span>
                </td>
                <td>
                  <a id="information_list_day">{{information_list.day}}</a>
                  <a
                    v-bind:class="[{emergency:information_list.importance == '緊急'},
                                    {important_2:information_list.importance == '最重要'},
                                    {important_1:information_list.importance == '重要'},
                                    {failure:information_list.importance == '障害情報'}]">
                    【{{information_list.importance}}】
                  </a>
                  <a>【{{information_list.target}}】</a>
                </td>
              </tr>
              <tr>
                <td></td>
                <td id="information_list_text">
                  <a><span v-html="information_list.text"></span></a>
                </td>
              </tr>
              <tr>
              </tr>
            </span>
          </table>
        </div>
      </div>
    </section>
    <modal name="important_info"
       class="important_info"
       width="60%">
       <h1>重要なお知らせ</h1>
       <div class="important_text">
         <span v-html="modal_text"></span>
       </div>
   </modal>
  </div>
</template>
<script>
import {
  LOGIN_SUCCESS,
  MODAL
} from '@/vuex/mutation_types'
import { mapActions } from 'vuex'
import isMobile from 'ismobilejs'
import arraysort from 'array-sort'

export default {
  data () {
    return {
      active: true,
      test1: '',
      idtext: '',
      password: '',
      isShownPassword: false,
      information_list: [],
      time: new Date(),
      modal_switch: false,
      modal_text: null
    }
  },
  methods: {
    ...mapActions([
      'getInformation'
    ]),
    doLogin () {
      let isSmartPhone = isMobile.phone
      let creds = {
        id: this.idtext,
        password: this.password
      }
      this.$store.dispatch('login', creds).then(
        () => {
          this.$store.commit(LOGIN_SUCCESS)
          if (this.$route.query.redirect === undefined) {
            if (isSmartPhone) {
              // スマホからのアクセスの場合
              this.$router.push('/SpTop')
            } else {
              // スマホ以外からのアクセスの場合
              this.$router.push('/table')
            }
          } else {
            this.$router.push(this.$route.query.redirect)
          }
        }
      ).catch(
        // ログイン後リダイレクトする処理の関係で，エラーハンドリングはここで行う
        (err) => {
          if (err.response) {
            let status = err.response.status
            let message = err.response.data.message
            if (status === 400) {
              alert('IDとパスワードを入力して下さい')
            } else if (status === 401) {
              alert('IDまたはパスワードが違います')
            } else {
              console.log(message)
              alert('ログインに失敗しました：' + message)
            }
          } else {
            alert('Error:' + err.message)
          }
          return
        }
      )
    },
    checke_date (inputdate) {
      var indate = (new Date(inputdate.day))
      var indetaY = indate.getFullYear()
      var indateM = indate.getMonth() + 1
      var indated = indate.getDate()
      var nowTimeY = this.time.getFullYear()
      var nowTimeM = this.time.getMonth() + 1
      var nowTimed = this.time.getDate()
      return (indetaY === nowTimeY && nowTimeM === indateM && (nowTimed - indated) <= 7 && (nowTimed - indated) >= 0)
    },
    show () {
      this.$modal.show('important_info')
    },
    hide () {
      this.$modal.hide('important_info')
    }
  },
  mounted () {
    this.getInformation().then((res) => {
      this.information_list = res
    }).then((res) => {
      var x = this.information_list.filter(
        (v) => ((v.importance === '緊急')))
      var y = null
      x = arraysort(x, 'show_date')
      x.forEach(function (value) {
        var indate = (new Date(value.show_date))

        var now = new Date()
        if (indate > now) {
          y = {
            modal_switch: true,
            modal_text: value.text
          }
        }
      })
      this.modal_switch = y.modal_switch
      if (this.modal_switch === true) {
        this.$modal.show('important_info')
        var s = y.modal_text.replace(/<p>/g, '')
        s = s.replace(/<\/p>/g, '')
        s = s.replace(/<br>/g, '　')
        this.$store.commit(MODAL, s)
      }
      this.modal_text = y.modal_text
    })
  }
}
</script>

<style lang="css" scoped>
.labels {
  float: left;
}
.logo{
  width: 10%;
  position: absolute;
  right: 0;
  bottom: 0;
}

#loginform {
  width: 300px;
  text-align: center;
  margin:auto;
}

.inputArea {
  text-align: right;
}
div {
  margin: 5px;
}
#information_list {
  overflow: auto;
  max-height: 320px;
  max-width: 700px;
  margin: 10px auto 10px auto;
}
.information_img{
  width: 5%;
  display: inline-block;
  float: left;
}
.information_img img{
  margin-top: 0;
}
.information_list_title{
  position: relative;
  font-size: 30px;
  font-weight: bold;
  width: 150px;
  display: block;
  margin: 10px auto;
  background: linear-gradient(transparent 70%, #a7d6ff 70%);
}
table{
  width: 100%;
  text-align: left;
}
#information_list_text{
  padding: 0 30px;
}
.info_Heading{
}
.kokuban {
  font-family: HuiFontP109;
  color: #fff;
  background-color: #114400;
  margin: 10px 0 10px 0;
  padding: 15px;
  border: 9px solid #a60;
  border-radius: 3px;
  box-shadow: 2px 2px 4px #666, 2px 2px 2px #111 inset;
  text-shadow: 0px 0px 2px #000;
  line-height: 1.9;
}
.tablea{
  display: block;
}
.failure{
  background-color: rgb(218, 199, 23);
  color: rgb(0, 0, 0);
  border-radius: 5px;
}
.important_1{
  background-color: rgb(222, 21, 45);
  color: rgb(255, 255, 255);
  border-radius: 5px;
}
.important_2{
  background-color: rgb(85, 0, 0);
  color: rgb(255, 255, 255);
  font-weight: bold;
  border-radius: 5px;
}
.emergency{
  background-color: rgb(150, 54, 162);
  color: rgb(255, 255, 255);
  font-weight: bold;
  border-radius: 5px;
  -webkit-animation:blink 0.5s ease-in-out infinite alternate;
    -moz-animation:blink 0.5s ease-in-out infinite alternate;
    animation:blink 0.5s ease-in-out infinite alternate;
}
@-webkit-keyframes blink{
    0% {opacity:0;}
    100% {opacity:1;}
}
@-moz-keyframes blink{
    0% {opacity:0;}
    100% {opacity:1;}
}
@keyframes blink{
    0% {opacity:0;}
    100% {opacity:1;}
}
.important_info h1{
  font-weight: bold;
  font-size: 4vw;
  text-align: center;
}
.important_text{
  width: 70%;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// Login.vue?e5dd0e2e